/* generated file - do not modify */
var onWindowIntl = function () {
  require('thunderball-client/lib/render/pageBuilder')(
    require('./browser/createRoutes'), [
      require('../../appInjectors'),
      require('./injectors')
    ],
    'en',
    {"authorized":true}
  );

  const { addLocaleData } = require('react-intl');
  [
    require('react-intl/locale-data/en')
  ].forEach((locale) => addLocaleData(locale));
}

var ensureFetch = function (cb) {
  if (typeof fetch === 'undefined') {
    require.ensure([], (require) => {
      require('whatwg-fetch')
      cb()
    })
  } else {
    cb()
  }
}

var ensureIntl = function (cb) {
  if (typeof window.Intl === 'undefined') {
    require.ensure([
      'intl',
      'intl/locale-data/jsonp/en.js'
    ], (require) => {
      require('intl');
      require('intl/locale-data/jsonp/en.js');
      cb();
    });
  } else {
    cb()
  }
}

// Check window.Intl, then check window.fetch, then load
ensureIntl(function () {
  ensureFetch(onWindowIntl)
})



// WEBPACK FOOTER //
// ./src/modules/profile/index.generated.js